export default __webpack_public_path__ + "4658a8dc4a260930c451ceadb35fcbab.svg";